export default "__VITE_ASSET__Bu_2hzZp__"